import cuid from "cuid";
import { isUndefined } from "lodash";
import { useState } from "react";
import { MdArrowForward } from "react-icons/md";
import { PROFILE_LIST } from "utils/constants";
import crossWorker from "../Assets/images/crossWorker.svg";
import individual from "../Assets/images/individual.svg";
import publicWorker from "../Assets/images/publicWorker.svg";
import selfEmployed from "../Assets/images/selfEmployed.svg";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Input from "../Components/Input";
import Layout from "../Components/Layout";

function View({ contact, onNext }) {
  const [selectedValue, setSelectedValue] = useState(contact?.profession);

  return (
    <Layout>
      <Header
        title="Votre situation ?"
        highlight="situation"
        subtitle="Régime"
      />

      <Input
        type="radio"
        variant="image"
        size={4}
        defaultValue={selectedValue}
        values={[
          {
            image: individual,
            label: "Particulier",
            value: PROFILE_LIST.PARTICULAR,
            subLabel:
              "Accédez à nos offres adaptées à tout profil de particulier",
          },
          {
            image: selfEmployed,
            label: "Indépendant",
            value: PROFILE_LIST.TNS,
            subLabel:
              "Pour vous TNS, artisans, commerçants, indépendants, professions libérales",
          },
          {
            image: publicWorker,
            value: PROFILE_LIST.TERRITORIAL_AGENT,
            label: "Agent territorial",
            subLabel:
              "L’offre labelisée pour les agents des collectivités territoriales",
          },
          {
            image: crossWorker,
            value: PROFILE_LIST.CROSS_BORDER_WORKER,
            label: "Frontalier",
            subLabel:
              "Frontalier demandez un devis sur mesure pour vous et vos salariés",
          },
        ]}
        onChange={setSelectedValue}
      />

      <ActionButtons
        onNext={() =>
          onNext({
            payload: {
              contact: {
                id: cuid(),
                ...contact,
                fields: {
                  ...contact?.fields,
                  profile: selectedValue,
                },
              },
            },
          })
        }
        disabled={isUndefined(selectedValue)}
        icon={<MdArrowForward size={24} />}
        buttonText="Allons-y !"
      />
    </Layout>
  );
}

export default View;
